import React from "react";

const AchievementSection = () => {
  return (
    <div
      className="section-full site-bg-white py-3 twm-achievement-section-wrap wow fadeInDown py-5"
      data-wow-offset="100"
      data-wow-delay="0.2"
    >
      <div className="container">
        <div className="row twm-achievement-section-bx">

          {/* Left Section */}
          <div className="col-xl-5 col-lg-6 col-md-12">
            <div className="twm-achievement-section">
              <div className="section-head left">
                <div className="twm-sm-title left">Our Achievements</div>
                <h2 className="twm-large-title site-text-dark">
                  Your Trusted Partner for Safe Travel
                </h2>
                <p>
                  We take pride in providing top-quality cab services with professional drivers,
                  well-maintained vehicles, and 24/7 customer support to ensure a smooth journey.
                </p>
              </div>
            </div>
          </div>

          {/* Right Section */}
          <div className="col-xl-7 col-lg-6 col-md-12">
            <div className="twm-achievement-section-right">
              <div className="row">

                {/* Item 1 */}
                <div className="col-md-6 m-b30">
                  <div className="twm-left-with-icon">
                    <div className="icon-media">
                      <img src="images/icons/rental.png" alt="Rides Completed" />
                    </div>
                    <span className="counter">8500</span>
                    <em className="symble">+</em>
                    <h3 className="icon-content-info">Rides Completed</h3>
                  </div>
                </div>

                {/* Item 2 */}
                <div className="col-md-6 m-b30">
                  <div className="twm-left-with-icon">
                    <div className="icon-media">
                      <img src="images/icons/man.png" alt="Happy Customers" />
                    </div>
                    <span className="counter">6200</span>
                    <em className="symble">+</em>
                    <h3 className="icon-content-info">Happy Customers</h3>
                  </div>
                </div>

                {/* Item 3 */}
                <div className="col-md-6 m-b30">
                  <div className="twm-left-with-icon">
                    <div className="icon-media">
                      <img src="images/icons/car-insurance.png" alt="Fleet Size" />
                    </div>
                    <span className="counter">350</span>
                    <em className="symble">+</em>
                    <h3 className="icon-content-info">Vehicles in Fleet</h3>
                  </div>
                </div>

                {/* Item 4 */}
                <div className="col-md-6 m-b30">
                  <div className="twm-left-with-icon">
                    <div className="icon-media">
                      <img src="images/icons/work-time.png" alt="Experience" />
                    </div>
                    <span className="counter">10</span>
                    <em className="symble">+</em>
                    <h3 className="icon-content-info">Years of Service</h3>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AchievementSection;